<template>
  <SectionShell
    :icon="meta.icon || 'check-circle'"
    :label="meta.label || fieldKey"
    :count="cur != null ? 1 : 0"
    :total="totalVals"
    :open="open"
    @toggle="open = $event"
  >
    <div :style="{ display: 'flex', gap: '4px', padding: '2px 2px 0' }">
      <button
        v-for="[label, v, c] in opts"
        :key="label"
        :style="{
          flex: 1,
          padding: '6px 8px',
          borderRadius: '7px',
          cursor: 'pointer',
          fontFamily: 'inherit',
          fontSize: '12px',
          fontWeight: 700,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '6px',
          border: `1px solid ${isActive(v) ? 'var(--p-primary-500)' : 'var(--p-content-border-color)'}`,
          background: isActive(v) ? 'var(--p-highlight-background, color-mix(in srgb, var(--p-primary-500) 14%, transparent))' : 'transparent',
          color: isActive(v) ? 'var(--p-text-color)' : 'var(--p-text-muted-color)',
        }"
        @click="search.setValue(fieldKey, v)"
      >
        {{ label }}
        <span
          v-if="facet.status === 'ready' && c != null"
          :style="{ fontSize: '10.5px', fontFamily: mono, color: 'var(--p-surface-400)', fontVariantNumeric: 'tabular-nums' }"
        >{{ c }}</span>
      </button>
    </div>
  </SectionShell>
</template>

<script setup>
// Boolean tri-state section (Any / Yes / No) with live counts. Ported from
// fql-search.jsx BooleanSection.
import { ref, computed } from 'vue'
import { useFacetValues } from '@/admin-collection-layout/composables/useStructuredSearch.js'
import { mono } from './bits.js'
import SectionShell from './SectionShell.vue'

// SearchSidebar hands every section the same prop bag. This one reads no decl,
// and `inheritAttrs: false` keeps the undeclared binding off SectionShell's
// root element rather than letting it render there as an attribute.
defineOptions({ name: 'BooleanSection', inheritAttrs: false })

const props = defineProps({
  fieldKey: { type: String, required: true },
  fieldSlot: { type: Object, required: true },
  meta: { type: Object, default: () => ({}) },
  search: { type: Object, required: true },
  facetProvider: { type: Function, default: null },
  debounceMs: { type: Number, default: 220 },
})

const open = ref(false)
const cur = computed(() => (props.fieldSlot.values.has('true') ? 'true' : props.fieldSlot.values.has('false') ? 'false' : null))
const facet = useFacetValues({
  field: () => props.fieldKey,
  query: () => props.search.query,
  facetProvider: props.facetProvider,
  enabled: () => open.value,
  debounceMs: () => props.debounceMs,
})
const counts = computed(() => {
  const m = {}
  facet.values.forEach((o) => {
    m[o.value] = o.count
  })
  return m
})
const total = computed(() => facet.values.reduce((n, o) => n + (o.count || 0), 0))
const opts = computed(() => [
  ['Any', null, total.value],
  ['Yes', 'true', counts.value.true],
  ['No', 'false', counts.value.false],
])
const totalVals = computed(() => (facet.status === 'ready' || facet.status === 'loading' ? facet.values.length : null))
const isActive = (v) => (v == null && cur.value == null) || cur.value === v
</script>
